"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSignatureEvents = void 0;
var useSignatureEvents_hook_1 = require("../../security/hooks/useSignatureEvents.hook");
Object.defineProperty(exports, "useSignatureEvents", { enumerable: true, get: function () { return useSignatureEvents_hook_1.useSignatureEvents; } });
//# sourceMappingURL=index.js.map